module.exports = __webpack_public_path__ + "img/arrow-down-square.c2026bd1.svg";